export enum QuestionType {
    FreeText=1,
    RadioButton=2,
    MultipleChoice=3,
    Scale=4,
    Description=5,
    MatrixTable=6,
    RoleProfile=7
}
